// About Deep and the biz
const aboutData = {
  // firstLetterOfFirstName: 'D',
  name: 'Deep Duggal',
  title: 'Modern Websites By Deep Duggal',
  shortDescription: 'Deep develops business solutions and software in North Carolina. He specializes in the latest web technologies. Deep can create a custom solution for your business.',
};

export default aboutData;